exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.heart-unfilled[data-v-698494a6] {\n  fill: #B0B0B0;\n}", ""]);

// exports
